import { useDispatch } from 'react-redux'

import { authActions } from '@/store/auth/auth.slice'
import { clientsActions } from '@/store/shop/clients/clients.slice'
import { ordersActions } from '@/store/shop/orders/orders.slice'
import { bindActionCreators } from '@reduxjs/toolkit'

const actions = {
  ...authActions,
  ...clientsActions,
  ...ordersActions,
}

export const useActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
